import type { Blockchain } from "@anaconda/core/blockchain/types"
import { createScope } from "bunshi"

export type BlockchainFilter = Blockchain | "ALL"

export interface BlockchainFiltersState {
  selectedBlockchain: BlockchainFilter
}

export const BlockchainFiltersScope = createScope<BlockchainFiltersState>({
  selectedBlockchain: "ALL",
})
